import style from '../SharedConfigs/css'
import bankingConfigs from '../SharedConfigs/banking'

const yellowTheme = {
  config: {
		...bankingConfigs()
  },
  theme: {
    input: {
		  borderRadius: '10px'
		},
		headings: {
			color: '#ffffff'
		},
		labels: {
			color: '#ffffff'
		},
		buttons: {
		  color: '#21211F'
		},
		cashierbackground: {
		  color: '#777777'
		},
		border: {
		  radius: '10px'
		}
  },
  style
}

export default yellowTheme
